import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "parseUrlDateStringToDate"
})
export class ParseUrlDateStringToDatePipe implements PipeTransform {
  transform(urlDate: string): Date | undefined {
    if (!urlDate) {
      return undefined;
    }
    const parts = urlDate.split("-");
    if (!parts) {
      return undefined;
    } else {
      if (parts.length !== 4) {
        return undefined;
      }
  
      const time = parts.pop();
      if (time && time.includes(':')) {
        const date = parts.join("-");
        return new Date(date + "T" + time);
      } else {
        return undefined
      }
    }
   
  }
}
